import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo-vinomiam.svg";

function Head() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const title = "Vinomiam";

  // Basculer le menu (ouvrir/fermer)
  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  // Fermer le menu si clic en dehors
  const handleClickOutside = (event) => {
    if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
    ) {
      setMenuOpen(false);
    }
  };

  // Ajouter ou enlever les gestionnaires pour détecter le clic
  useEffect(() => {
    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  const currentYear = new Date().getFullYear();

  return (
      <div>
        {/* Balises header */}
        <header className="header">
          <div className="header-left">
            <img src={logo} alt="Vinomiam Logo" className="logo" />
            <h1 className="title">{title}</h1>
          </div>
          {/* Bloc META pour support mobile */}
          <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0, user-scalable=no"
          />
          <button
              ref={buttonRef}
              className="menu-button"
              onClick={toggleMenu}
              aria-haspopup="true"
              aria-expanded={menuOpen}
              aria-label="Basculer le menu"
          >
            {menuOpen ? "✖" : "☰"}
          </button>
        </header>

        {/* Menu Navigation */}
        <nav
            ref={menuRef}
            className={`menu-slide ${menuOpen ? "active" : ""}`}
            aria-hidden={!menuOpen}
        >
          <div className="menu-header">
            <h2>Menu</h2>
          </div>
          <ul className="menu-content">
            <li className="menu-item">
              <Link to="/utilisation-vinomiam" onClick={toggleMenu}>
                Utilisation Vinomiam
              </Link>
            </li>
            <li className="menu-item">
              <Link to="/historique" onClick={toggleMenu}>
                Historique des conversations
              </Link>
            </li>
            <li className="menu-item">
              <a
                  href="https://choisirvin.com"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => setMenuOpen(false)}
              >
                En savoir plus sur le Vin <strong>↗</strong>
              </a>
            </li>
            <li className="menu-item">
              <Link to="/mentions-legales" onClick={toggleMenu}>
                Mentions Légales & CGV
              </Link>
            </li>
          </ul>
          <p className="menu-copyright">
            <div>
              © {currentYear} Vinomiam - Tous droits réservés.
              <br />
              L'abus d'alcool est dangereux pour la santé, à consommer avec
              modération.
            </div>
          </p>
        </nav>

        {/* Bouton de fermeture menu */}
        {menuOpen && (
            <button
                className="close-menu-outside"
                onClick={toggleMenu}
                aria-label="Fermer le menu"
            >
              ✖
            </button>
        )}
      </div>
  );
}

export default Head;